export const dropdownOptions = {
  'Complete': [
    { value: 'Yes', label: 'Yes', color: '#16a34a' },         // Green-600 - success
    { value: 'No', label: 'No', color: '#ea580c' },           // Orange-600 - gentle error  
    { value: 'Not Required', label: 'Not Required', color: '#6b7280' }, // Gray-500 - neutral
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Stakeholders': [
    { value: 'Plan Sponsor', label: 'Plan Sponsor', color: '#0ea5e9' },         // Sky-500
    { value: 'TPA', label: 'TPA', color: '#2563eb' },                          // Blue-600  
    { value: 'Recordkeeper', label: 'Recordkeeper', color: '#15803d' },       // Green-700
    { value: 'Participants', label: 'Participants', color: '#f59e0b' },        // Amber-500 - light orange
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Priority': [
    { value: 'High', label: 'High', color: '#ef4444' },       // Red-500 - urgent
    { value: 'Medium', label: 'Medium', color: '#f59e0b' },    // Amber-500 - warning
    { value: 'Low', label: 'Low', color: '#22c55e' },          // Green-500
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Reporting Quarter': [
    { value: 'All', label: 'All', color: '#16a34a' },          // Green-600
    { value: 'Q1', label: 'Q1', color: '#0ea5e9' },          // Sky-500 - soft blue
    { value: 'Q2', label: 'Q2', color: '#f59e0b' },          // Amber-500 - warm
    { value: 'Q3', label: 'Q3', color: '#8b5cf6' },          // Violet-500 - soft purple
    { value: 'Q4', label: 'Q4', color: '#ec4899' },          // Pink-500 - soft pink
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Reporting Year': [
    { value: 'All', label: 'All', color: '#0284c7' },          // Sky-600
    { value: '2025', label: '2025', color: '#1f2937' },  // Gray-800 (number value)
    { value: '2024', label: '2024', color: '#374151' },  // Gray-700 (number value)
    { value: 'Select...', label: 'Select...', color: '#64748b' }, // Slate-500 - neutral
  ],
  'Quarter': [
    { value: 'Q1', label: 'Q1', color: '#0ea5e9' },          // Sky-500 - soft blue
    { value: 'Q2', label: 'Q2', color: '#f59e0b' },          // Amber-500 - warm
    { value: 'Q3', label: 'Q3', color: '#8b5cf6' },          // Violet-500 - soft purple
    { value: 'Q4', label: 'Q4', color: '#ec4899' },          // Pink-500 - soft pink
    { value: 'All', label: 'All', color: '#16a34a' },        // Green-600
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Include In Annual Review Report': [
    { value: 'Yes', label: 'Yes', color: '#22c55e' },       // Green-500
    { value: 'No', label: 'No', color: '#ef4444' },         // Red-500
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Include in Next Year\'s Plan Data': [
    { value: 'Yes', label: 'Yes', color: '#22c55e' },       // Green-500
    { value: 'No', label: 'No', color: '#ef4444' },         // Red-500
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Time Spent': [
    { value: 0, label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
    { value: 15, label: '15', color: '#38bdf8' },         // Sky-400
    { value: 30, label: '30', color: '#0ea5e9' },         // Sky-500
    { value: 45, label: '45', color: '#0284c7' },         // Sky-600
    { value: 60, label: '60', color: '#0369a1' },         // Sky-700
    { value: 75, label: '75', color: '#075985' },         // Sky-800
    { value: 90, label: '90', color: '#0c4a6e' },         // Sky-900
    { value: 105, label: '105', color: '#082f49' },       // Sky-950
    { value: 120, label: '120', color: '#020617' },       // Slate-950
  ],
  'Comprehensive Plan Review': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },      // Sky-500
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' }, // Green-700
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },    // Red-700
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },        // Sky-700
    { value: 'Weekly', label: 'Weekly', color: '#166534' },          // Green-800
    { value: 'Daily', label: 'Daily', color: '#991b1b' },            // Red-800
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },    // Sky-900
    { value: 'None', label: 'None', color: '#6b7280' },              // Gray-500
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Review Investment Policy Statement': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Review Investment Menu, Performance, and Providers': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Select Alternatives To Address Over and Under Concentration': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Serve as a Co-Fiduciary Under ERISA': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Assess fidelity bonding': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Compliance Check & Fee Disclosure': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Assess Current Employee Education Program': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Plan and Implement Effective Employee Education Program': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Targeted Education Meetings, Including Re-Enrollment': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Limited One-On-One Support Via Phone': [
    { value: 'Annually', label: 'Annually', color: '#0ea5e9' },
    { value: 'Semi-Annually', label: 'Semi-Annually', color: '#15803d' },
    { value: 'Quarterly', label: 'Quarterly', color: '#b91c1c' },
    { value: 'Monthly', label: 'Monthly', color: '#0369a1' },
    { value: 'Weekly', label: 'Weekly', color: '#166534' },
    { value: 'Daily', label: 'Daily', color: '#991b1b' },
    { value: 'As Needed', label: 'As Needed', color: '#0c4a6e' },
    { value: 'None', label: 'None', color: '#6b7280' },
    { value: 'Select...', label: 'Select...', color: '#6b7280' }, // Gray-500 - neutral
  ],
  'Due Date': [
    { value: 'Date', label: 'Date', color: '#0ea5e9' },
  ],
  'Complete': [
    { value: 'Yes', label: 'Yes', color: '#22c55e' },
    { value: 'No', label: 'No', color: '#f97316' }, // Orange instead of red - gentler
    { value: 'Select...', label: 'Select...', color: '#6b7280' },
  ],
  'Watch List Status': [
    { value: 'Not On Watchlist', label: 'Not On Watchlist', color: '#22c55e' }, // Green-500
    { value: 'Watch', label: 'Watch', color: '#f59e0b' }, // Amber-500
    { value: 'Remove', label: 'Remove', color: '#f97316' }, // Orange-500
    { value: 'Proposed', label: 'Proposed', color: '#0ea5e9' }, // Sky-500
    { value: 'Select...', label: 'Select...', color: '#6b7280' },
  ],
  'Current': [
    { value: true, label: 'Up To Date', color: '#22c55e' }, // Green-500
    { value: false, label: 'Out Of Date', color: '#f97316' }, // Orange-500
  ],
};